"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VCheckbox;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

require("./VCheckbox.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getCheckmark(color) {
  return "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='7' viewBox='0 0 9 7'%3E%3Cpath d='M1.67929 2.76613C1.27398 2.39097 0.641287 2.41541 0.266127 2.82071C-0.109033 3.22602 -0.0845938 3.85871 0.320713 4.23387L1.67929 2.76613ZM3.70089 6L3.02161 6.73387C3.22276 6.92006 3.49151 7.01552 3.76504 6.99794C4.03857 6.98036 4.2929 6.85127 4.46855 6.64086L3.70089 6ZM8.64266 1.64086C8.9966 1.21689 8.93983 0.586277 8.51586 0.232341C8.09189 -0.121596 7.46128 -0.0648248 7.10734 0.359142L8.64266 1.64086ZM0.320713 4.23387L3.02161 6.73387L4.38018 5.26613L1.67929 2.76613L0.320713 4.23387ZM4.46855 6.64086L8.64266 1.64086L7.10734 0.359142L2.93323 5.35914L4.46855 6.64086Z' fill='".concat(color, "'/%3E%3C/svg%3E\")");
}

function getCheckmarkSmall(color) {
  return "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='6' viewBox='0 0 7 6'%3E%3Cpath d='M1.07908 2.47765C0.87118 2.2959 0.555308 2.3171 0.373562 2.525C0.191815 2.73291 0.213018 3.04878 0.420919 3.23052L1.07908 2.47765ZM2.77567 4.62492L2.44659 5.00136C2.65368 5.1824 2.96812 5.16216 3.1503 4.95606L2.77567 4.62492ZM6.28088 1.41439C6.46376 1.20749 6.44429 0.891511 6.23739 0.708626C6.03049 0.525741 5.71451 0.545209 5.53162 0.752109L6.28088 1.41439ZM0.420919 3.23052L2.44659 5.00136L3.10475 4.24848L1.07908 2.47765L0.420919 3.23052ZM3.1503 4.95606L6.28088 1.41439L5.53162 0.752109L2.40104 4.29378L3.1503 4.95606Z' fill='".concat(color, "'/%3E%3C/svg%3E\")");
}

var useStyles = (0, _styles.makeStyles)({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  rootSmall: {
    paddingTop: 0,
    paddingBottom: 0
  },
  icon: {
    borderRadius: 4,
    width: 24,
    height: 24,
    boxShadow: 'inset 0 0 0 1px ' + _Colors.default.hall1,
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:hover ~ &': {
      boxShadow: 'inset 0 0 0 1px ' + _Colors.default.sinineVaal,
      transition: 'all 0.2s ease'
    },
    'input:disabled ~ &': {
      boxShadow: 'inset 0 0 0 1px rgba(168, 173, 180, 0.8)'
    }
  },
  iconSmall: {
    width: 18,
    height: 18
  },
  checkedIcon: {
    boxShadow: 'inset 0 0 0 1px ' + _Colors.default.sinineVaal,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 9,
      height: 7,
      marginLeft: 7,
      marginTop: 8,
      backgroundImage: getCheckmark(_Colors.default.sinineVaal),
      content: '""'
    },
    'input:disabled ~ &': {
      '&:before': {
        backgroundImage: getCheckmark(_Colors.default.hall1)
      }
    }
  },
  checkedIconSmall: {
    '&:before': {
      width: 7,
      height: 6,
      marginLeft: 5.5,
      marginTop: 6,
      backgroundImage: getCheckmarkSmall(_Colors.default.sinineVaal)
    },
    'input:disabled ~ &': {
      '&:before': {
        backgroundImage: getCheckmarkSmall(_Colors.default.hall1)
      }
    }
  }
});
/**
 * @visibleName Checkbox
 */

function VCheckbox(props) {
  var classes = useStyles();
  var rootClass = classes.root;
  var iconClass = classes.icon;
  var checkedIconClass = (0, _clsx.default)(iconClass, classes.checkedIcon);

  if ((props === null || props === void 0 ? void 0 : props.size) === 'small') {
    rootClass = (0, _clsx.default)(rootClass, classes.rootSmall);
    iconClass = (0, _clsx.default)(iconClass, classes.iconSmall);
    checkedIconClass = (0, _clsx.default)(checkedIconClass, classes.iconSmall, classes.checkedIconSmall);
  }

  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
    className: rootClass,
    disableRipple: true,
    color: "default",
    checkedIcon: /*#__PURE__*/_react.default.createElement("span", {
      className: checkedIconClass
    }),
    icon: /*#__PURE__*/_react.default.createElement("span", {
      className: iconClass
    }),
    inputProps: {
      'aria-label': 'decorative checkbox'
    }
  }, props));
}